import * as yup from 'yup';

export const enrollmentLevelSchema = yup.number()
    .typeError('Selecione um nível válido')
    .integer('Selecione um nível válido')
    .positive('Selecione um nível válido')
    .max(Number.MAX_SAFE_INTEGER, 'Selecione um nível válido')
    .required('Nível é obrigatório');
